import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { addAuthToken, getUserAuthTokens, login, logout, restoreSession } from './user.thunks';
import { UserState } from './user.types';

export const loginReducer = (builder: ActionReducerMapBuilder<UserState>): void => {
  builder
    .addCase(login.pending, state => {
      state.loading = 'pending';
    })
    .addCase(login.fulfilled, (state, action) => {
      if (!action.payload) {
        state.authenticated = false;
        state.loading = 'failed';
        return;
      }
      state.authenticated = true;
      state.loading = 'succeeded';
      state.role = action.payload?.role || null;
      state.login = action.payload?.login || null;
      state.userData = action.payload?.userData || null;
      state.token = action.payload?.token || null;
      state.authTokens = action.payload?.authTokens || null;
    })
    .addCase(login.rejected, state => {
      state.authenticated = false;
      state.loading = 'failed';
    });
};

export const restoreSessionReducer = (builder: ActionReducerMapBuilder<UserState>): void => {
  builder
    .addCase(restoreSession.pending, state => {
      state.loading = 'pending';
    })
    .addCase(restoreSession.fulfilled, (state, action) => {
      if (!action.payload) {
        state.authenticated = false;
        state.loading = 'succeeded';
        return;
      }
      state.authenticated = true;
      state.loading = 'succeeded';
      state.login = action.payload?.login || null;
      state.role = action.payload?.role || null;
      state.userData = action.payload?.userData || null;
      state.token = action.payload?.token || null;
      state.authTokens = action.payload?.authTokens || null;
    })
    .addCase(restoreSession.rejected, state => {
      state.authenticated = false;
      state.loading = 'failed';
      // TODO: error management to be discussed in the team
    });
};

export const logoutReducer = (builder: ActionReducerMapBuilder<UserState>): void => {
  builder
    .addCase(logout.pending, state => {
      state.loading = 'pending';
    })
    .addCase(logout.fulfilled, state => {
      state.authenticated = false;
      state.loading = 'succeeded';
      state.role = null;
      state.login = null;
      state.userData = null;
      state.token = null;
    })
    .addCase(logout.rejected, state => {
      state.loading = 'failed';
    });
};

export const getTokensReducer = (builder: ActionReducerMapBuilder<UserState>): void => {
  builder.addCase(getUserAuthTokens.fulfilled, (state, action) => {
    state.authTokens = action.payload;
  });
};

export const addTokenReducer = (builder: ActionReducerMapBuilder<UserState>): void => {
  builder.addCase(addAuthToken.fulfilled, (state, action) => {
    if (action.payload) {
      if (state.authTokens) {
        state.authTokens.push(action.payload);
      } else {
        state.authTokens = [action.payload];
      }
    }
  });
};
